class CountDownTimer {
    // Initializes the application
    constructor() {
        this.init();
    }

    // Sets up event listeners and initializes components
    init() {
        document.addEventListener("DOMContentLoaded", () => {
            this.initCountdown();
        });
    }

    // Creates and initializes the countdown functionality
    initCountdown() {
        const countdownManager = new CountdownManager();
        countdownManager.init();
    }
}

class CountdownManager {
    // Initializes countdown timers for all matching elements
    init() {
        const countdownWrappers = document.querySelectorAll("[data-countdown-wrapper]");
        if (!countdownWrappers.length) return;

        countdownWrappers.forEach(wrapper => this.setupCountdown(wrapper));
    }

    // Sets up individual countdown timer for a wrapper element
    // @param {Element} wrapper - DOM element containing countdown
    setupCountdown(wrapper) {
        const rawDate = wrapper.dataset.countdown;
        if (!rawDate) return;

        const targetDate = this.parseDate(rawDate);
        const elements = this.getCountdownElements(wrapper);

        this.startCountdown(targetDate, elements);
    }

    // Converts date string to timestamp
    // @param {string} rawDate - Date string in DD/MM/YYYY format
    // @returns {number} Timestamp
    parseDate(rawDate) {
        const [day, month, year] = rawDate.split("/").map(Number);
        return new Date(year, month - 1, day, 0, 0, 0).getTime();
    }

    // Gets DOM elements for countdown display
    // @param {Element} wrapper - Container element
    // @returns {Object} Object containing countdown elements
    getCountdownElements(wrapper) {
        return {
            days: wrapper.querySelector("[data-count-down-days]"),
            hours: wrapper.querySelector("[data-count-down-hours]"),
            minutes: wrapper.querySelector("[data-count-down-minutes]"),
            seconds: wrapper.querySelectorAll("[data-count-down-seconds]")
        };
    }

    // Starts countdown timer with regular updates
    // @param {number} targetDate - Target timestamp
    // @param {Object} elements - DOM elements for display
    startCountdown(targetDate, elements) {
        const updateDisplay = () => {
            const timeLeft = this.calculateTimeLeft(targetDate);
            this.updateElements(elements, timeLeft);
            return timeLeft > 0;
        };

        if (updateDisplay()) {
            const interval = setInterval(() => {
                if (!updateDisplay()) clearInterval(interval);
            }, 1000);
        }
    }

    // Calculates remaining time
    // @param {number} targetDate - Target timestamp
    // @returns {number} Milliseconds remaining
    calculateTimeLeft(targetDate) {
        const now = new Date().getTime();
        return Math.max(0, targetDate - now);
    }

    // Updates display elements with time remaining
    // @param {Object} elements - DOM elements
    // @param {number} timeLeft - Time remaining in ms
    updateElements(elements, timeLeft) {
        if (timeLeft <= 0) {
            this.setZeros(elements);
            return;
        }

        const times = this.calculateTimes(timeLeft);
        this.updateDisplayValues(elements, times);
    }

    // Converts milliseconds to days, hours, minutes, seconds
    // @param {number} timeLeft - Time in milliseconds
    // @returns {Object} Formatted time values
    calculateTimes(timeLeft) {
        return {
            days: Math.floor(timeLeft / (1000 * 60 * 60 * 24)),
            hours: Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
            minutes: Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60)),
            seconds: Math.floor((timeLeft % (1000 * 60)) / 1000)
        };
    }

    // Sets all countdown elements to zero
    // @param {Object} elements - DOM elements
    setZeros(elements) {
        if (elements.days) elements.days.textContent = "0";
        if (elements.hours) elements.hours.textContent = "0";
        if (elements.minutes) elements.minutes.textContent = "0";
        elements.seconds.forEach(el => el.textContent = "0");
    }

    // Updates DOM elements with calculated times
    // @param {Object} elements - DOM elements
    // @param {Object} times - Time values to display
    updateDisplayValues(elements, times) {
        if (elements.days) elements.days.textContent = times.days;
        if (elements.hours) elements.hours.textContent = times.hours;
        if (elements.minutes) elements.minutes.textContent = times.minutes;
        elements.seconds.forEach(el => el.textContent = times.seconds);
    }
}

// Init the countdown
new CountDownTimer();